<template>
    <div>
        <awesome-picker ref="picker" :data="picker.data" :anchor="picker.anchor" :textTitle="picker.textTitle"
                :textConfirm="picker.textConfirm" :textCancel="picker.textCancel" :colorTitle="picker.colorTitle"
                :colorConfirm="picker.colorConfirm" :colorCancel="picker.colorCancel" :swipeTime="picker.swipeTime"
                @cancel="handlePickerCancel" @confirm="handlePickerConfirm">
        </awesome-picker>
    </div>
</template>

<script>
    import * as tool from '../../api/common';
    import { mapMutations, mapActions } from 'vuex'
    //import const_data from '../api/const_data';
    export default {
        data() {
            return {
                picker: {
                    data: [['a', 'b', 'c']],
                    textTitle: '小火柴话题卡',
                    textConfirm: '发送',
                    textCancel: '关闭',
                    colorTitle: '#1A1A1A',
                    colorConfirm: '#6C1AAB',
                    colorCancel: '#6C1AAB',
                    swipeTime: 1800
                }
            }
        },
        mounted() {
            this.init_page();
            this.show();
        },
        methods: {
            ...mapMutations(['get', 'post']), //引入方法

            init_page() {
                var const_data = this.$store.state.const_data;
                var ary_topic = const_data.topic;
                this.picker.data = [];
                this.picker.data.push(ary_topic);
            },
            show() {
                this.$refs.picker.show();
            },
            
            handlePickerConfirm(item) {
                var v = item[0].value;
                this.sendTopic(v);
            },
            handlePickerCancel(item) {
                this.$emit("close_topic");
            },

            sendTopic(v) {
                var item = { 'type':'topic', 'txt': v };
                this.$emit("send_topic", item);
            }
        }

    }
</script>

<style scoped>
</style>